var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_277)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M48.7224 25.6482V51.1306C48.7224 51.2172 48.2948 52.1097 48.1851 52.2754C47.485 53.3486 46.467 53.6725 45.2523 53.7628C33.5593 54.629 20.7953 53.0963 8.99248 53.7553C7.85723 53.8645 5.93866 52.1436 5.93866 51.1344V25.652H2.87728C2.00692 25.652 0.527311 24.3189 0.232146 23.4603C-0.452787 21.4608 0.466764 20.4064 1.82906 19.1562C8.69353 12.8599 17.3328 7.54277 24.2919 1.23524C26.3542 -0.527107 27.69 -0.199492 29.7297 1.23524C37.8013 6.91766 45.4756 14.2947 53.358 20.2972C55.4204 23.7767 52.166 26.247 48.7186 25.6482H48.7224ZM12.6783 21.3478V47.0411H17.7377V30.7846C17.7377 30.6905 18.1804 29.2444 18.2675 29.0072C20.9996 21.4871 33.0219 21.4871 35.7541 29.0072C35.8411 29.2444 36.2839 30.6942 36.2839 30.7846V47.0411H41.9752V21.5587C41.9752 21.2913 42.7548 20.2369 42.5921 20.0072L27.077 7.85532L12.1371 19.5553L11.8609 20.0524C12.0236 20.4026 12.6101 21.0277 12.6745 21.3516L12.6783 21.3478ZM24.4811 31.6244V47.0411H29.5405V31.6244C29.5405 30.875 28.4696 30.3139 27.7619 30.2461C26.5396 30.1294 24.7838 30.1068 24.4811 31.6244Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9d30aa96522141d675edf8eb9e5ad105.svg";
export { ForwardRef as ReactComponent };